var SingletonInstanceId = 'instance';
var CommonGroupTag = /*#__PURE__*/function (CommonGroupTag) {
  CommonGroupTag["variation"] = "variation";
  CommonGroupTag["current"] = "current";
  return CommonGroupTag;
}({});

export { CommonGroupTag, SingletonInstanceId };
//# sourceMappingURL=services.esm.js.map
